import countryList from 'react-select-country-list';

// Nomes de país em pt-BR. A react-select-country-list so tem ingles (e o nome nativo), entao
// a traducao vem do proprio navegador, sem dependencia nova (AD-015). O codigo ISO alpha-2
// continua sendo o valor gravado.

// Intl.DisplayNames: Chrome/Edge 81+, Firefox 86+, Safari 14.1+. Navegador mais antigo fica
// com o nome em ingles da lista, em vez de ficar sem pais nenhum.
const regionNamesPtBr = () => (
    typeof Intl.DisplayNames === 'function'
        ? new Intl.DisplayNames(['pt-BR'], { type: 'region' })
        : null
);

const foldText = text => text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

export const getCountries = () => {
    const names = regionNamesPtBr();
    const collator = new Intl.Collator('pt-BR');

    return countryList().getData()
        .map(({ value, label }) => ({
            code: value,
            name: names?.of(value) || label,
        }))
        .sort((a, b) => collator.compare(a.name, b.name));
};

export const searchCountries = (term = '') => {
    const folded = foldText(term);
    return getCountries().filter(country => foldText(country.name).includes(folded));
};

// Mesmo formato das opcoes do InputSearch, para o Select exibir o nome ao pre-preencher.
export const toCountryOption = ({ code, name }) => ({
    key: code,
    label: name,
    item: { key: code, label: name },
});

// Codigo desconhecido aparece como o proprio codigo, em vez de derrubar a tela.
export const countryOption = code => {
    if (!code) return null;
    const country = getCountries().find(c => c.code === code);
    return toCountryOption(country ?? { code, name: code });
};
